import tIcon from '../../../assets/icon/ic-t.svg';
import lineIcon from '../../../assets/icon/grip-lines.svg';
import squareIcon from '../../../assets/icon/square-line-icon.svg';
import circleIcon from '../../../assets/icon/circle-line-icon.svg';
import imageIcon from '../../../assets/icon/image-icon.svg';
import { TABLES } from '../../../Apis/Tables';
import { useDispatch } from 'react-redux';
import { SearchByFilters } from '../../../reduxToolkit/Search/SearchApi';
import { useTranslation } from 'react-i18next';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const FunctionalityTemplateDragBtn = ({ handleDragStart, setShowResources }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    // Handles the action to fetch resources by dispatching a search with filters.
    const handleGetResources = () => {
        const option = `${TABLES.RESOURCES}`;
        const body = {
            pagination: {
                page: 0,
                size: 100,
            },
            searchCriteriaList: [],
        };
        dispatch(SearchByFilters({ option, body }));
        setShowResources(true);
    };
    // Array of button data used for different templates (text, line, rectangle, ellipse, image).
    const buttonsData = [
        {
            iconSrc: tIcon,
            transferType: 'textTemplate',
            altText: 'textTemplate',
            onDragStart: handleDragStart,
            onClick: () => setShowResources(false),
        },
        {
            iconSrc: lineIcon,
            transferType: 'lineTemplate',
            altText: 'lineTemplate',
            onDragStart: handleDragStart,
            onClick: () => setShowResources(false),
            className: 'mt-1',
        },
        {
            iconSrc: squareIcon,
            transferType: 'rectangleTemplate',
            altText: 'rectangleTemplate',
            onDragStart: handleDragStart,
            onClick: () => setShowResources(false),
            className: 'mt-1',
        },
        {
            iconSrc: circleIcon,
            transferType: 'ellipseTemplate',
            altText: 'ellipseTemplate',
            onDragStart: handleDragStart,
            onClick: () => setShowResources(false),
            className: 'mt-1',
        },
        {
            iconSrc: imageIcon,
            transferType: 'imageTemplate',
            altText: 'imageTemplate',
            onDragStart: () => setShowResources(true),
            onClick: handleGetResources,
        },
    ];

    return { buttonsData, handleGetResources };
};
export default FunctionalityTemplateDragBtn;
